import React, {useEffect, useState} from 'react';
import {Button, TextField} from '@material-ui/core';
import {Autocomplete} from '@material-ui/lab';
import {Formik} from 'formik';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchServiceClientDropDownData,
  fetchBillingIndicatorsDropdownData,
  fetchCorporateNameDataBI,
  resetGetServiceClientData,
  resetCorporateNameData,
  resetAssignCompany,
} from '../../../redux/reducers/BillingIndicator/index';
import {
  fetchCompanyDropDownData,
  fetchSiteDataBasedOnCorporate,
  resetClientInfo,
  resetSiteDataOnCorporate,
} from '../../../redux/reducers/clientMangement/Organizaation';
import BillingMappingTable from './BillingMappingTable';
import reusableInputStyles from '../../../components/InputStyles';

const BillingSearchForm = ({setValue, setTabLabels}) => {
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const [companyIds, setCompanyIds] = useState({
    companyId: 0,
    corporateId: 0,
  });
  const {companyAPIdata, siteDataOnCorporate} = useSelector(({organization}) => organization);
  const {getBillingDropdownData, corporateNameData, getServiceClientData} = useSelector(
    ({billingIndicator}) => billingIndicator,
  );
  const dispatch = useDispatch();
  const initialValues = {
    billingIndicatorNumber: null,
    billingIndicatorName: null,
    company: null,
    corporate: null,
    site: null,
    serviceClient: null,
  };
  useEffect(() => {
    dispatch(fetchBillingIndicatorsDropdownData());
    dispatch(fetchCompanyDropDownData());
    dispatch(resetClientInfo());
    dispatch(resetAssignCompany());
  }, []);

  const handleSubmit = (values) => {
    setSubmit(true);
    setSearchData(values);
  };
  const onClear = () => {
    const data = {
      billingIndicatorNumber: null,
      billingIndicatorName: null,
      company: null,
      corporate: null,
      site: null,
      serviceClient: null,
    };
    setSearchData(data);
  };


  const handleInputChange = async (event, newInputValue, dropDownData, condition) => {
    const conditionToPropertyMap = {
      billingIndicatorNumber: 'billingIndicatorNumber',
      billingIndicatorName: 'billingIndicatorName',
      companyName: 'companyName',
      corporateName: 'corporateName',
      siteName: 'siteName',
      serviceClientName: 'serviceClientName',
    };

    const property = conditionToPropertyMap[condition];

    if (!property) {
      return [];
    }

    const filteredOptions = dropDownData?.filter((option) =>
      String(option[property])?.includes(newInputValue),
    );

    return filteredOptions;
  };


  return (
    <>
      <h2 className="search-title">Billing Indicator Search</h2>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
      >
        {(props) => {
          const {values, handleSubmit, setFieldValue, resetForm} = props;
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="form-row standard-field-textfields new-standard-textfields">
                <div className="col-sm-6 col-md-4 col-lg-4 form-group billingindicator-closeicon">
                  <Autocomplete
                    classes={{
                      option: classes.option,
                    }}
                    autoHighlightNotRequired={true}
                    name="billingIndicatorNumber"
                    id="billingIndicatorNumber"
                    size="small"
                    options={getBillingDropdownData || []}
                    getOptionLabel={(option) => {
                      return String(option.billingIndicatorNumber) || '';
                    }}
                    freeSolo
                    onInputChange={(e, inputVal) => {
                      handleInputChange(
                        e,
                        inputVal,
                        getBillingDropdownData,
                        'billingIndicatorNumber',
                      );
                    }}
                    onKeyPress={(e) => {
                      if ( e.target.value.length >= 4) {
                        e.preventDefault();
                      }
                    }}
                    onBlur={(e) => {
                      if (e?.target?.value) {
                        setFieldValue('billingIndicatorNumber', {
                          billingIndicatorNumber: e?.target?.value,
                        });
                      }
                    }}
                    onChange={(event, value) => {
                      if (event?.key === 'Enter' && typeof value !== 'object') {
                        setFieldValue('billingIndicatorNumber', {
                          billingIndicatorNumber: value,
                        });
                      } else {
                        setFieldValue('billingIndicatorNumber', value);
                      }
                    }}
                    value={values.billingIndicatorNumber}
                    renderInput={(params) => (
                      <div className="select-field custom-text-field ">
                        <TextField
                          {...params}
                          variant="outlined"
                          margin="dense"
                          type="number"
                          label="Billing Indicator Number"
                          placeholder="Select Billing Indicator Number"
                        />
                      </div>
                    )}
                  />
                </div>

                <div className={'col-sm-6 col-md-4 col-lg-4 form-group billingindicator-closeicon'}>
                  <Autocomplete
                    classes={{
                      option: classes.option,
                    }}
                    autoHighlightNotRequired={true}
                    name="billingIndicatorName"
                    id="billingIndicatorName"
                    size="small"
                    options={getBillingDropdownData || []}
                    getOptionLabel={(option) => {
                      return option.billingIndicatorName || '';
                    }}
                    freeSolo
                    onInputChange={(e, inputVal) => {
                      handleInputChange(
                        e,
                        inputVal,
                        getBillingDropdownData,
                        'billingIndicatorName',
                      );
                    }}
                    onBlur={(e) => {
                      if (e?.target?.value) {
                        setFieldValue('billingIndicatorName', {
                          billingIndicatorName: e?.target?.value,
                        });
                      }
                    }}
                    onChange={(event, value) => {
                      if (event?.key === 'Enter' && typeof value !== 'object') {
                        setFieldValue('billingIndicatorName', {
                          billingIndicatorName: value,
                        });
                      } else {
                        setFieldValue('billingIndicatorName', value);
                      }
                    }}
                    value={values.billingIndicatorName}
                    renderInput={(params) => (
                      <div className="select-field">
                        <TextField
                          {...params}
                          variant="outlined"
                          margin="dense"
                          label="Billing Indicator Name"
                          placeholder="Select Billing Indicator Name"
                        />
                      </div>
                    )}
                  />
                </div>
                <div className={'col-sm-6 col-md-4 col-lg-4 form-group billingindicator-closeicon'}>
                  <Autocomplete
                    classes={{
                      option: classes.option,
                    }}
                    autoHighlightNotRequired={true}
                    name="company"
                    id="company"
                    size="small"
                    options={companyAPIdata || []}
                    getOptionLabel={(option) => {
                      return option.companyName || '';
                    }}
                    freeSolo
                    onInputChange={(e, inputVal) => {
                      handleInputChange(e, inputVal, companyAPIdata, 'companyName');
                    }}
                    onBlur={(e) => {
                      if (e?.target?.value) {
                        setFieldValue('company', {
                          companyName: e?.target?.value,
                        });
                      }
                    }}
                    onChange={(event, value) => {
                      if (event?.key === 'Enter' && typeof value !== 'object') {
                        setFieldValue('company', {
                          companyName: value,
                        });
                      } else {
                        if (value && value?.companyName) {
                          dispatch(fetchCorporateNameDataBI(value?.companyId));
                          setCompanyIds((ids) => ({
                            ...ids,
                            companyId: value?.companyId,
                          }));
                        }
                        if (!value?.companyName) {
                          dispatch(resetCorporateNameData());
                        }
                        setFieldValue('corporate', '');
                        setFieldValue('site', '');
                        setFieldValue('serviceClient', '');
                        dispatch(resetGetServiceClientData());
                        dispatch(resetSiteDataOnCorporate());
                        setFieldValue('company', value);
                      }
                    }}
                    value={values.company}
                    renderInput={(params) => (
                      <div className="select-field">
                        <TextField
                          {...params}
                          variant="outlined"
                          margin="dense"
                          label="Company Name"
                          placeholder="Select Company Name"
                        />
                      </div>
                    )}
                  />
                </div>
                <div className={'col-sm-6 col-md-4 col-lg-4 form-group billingindicator-closeicon'}>
                  <Autocomplete
                    classes={{
                      option: classes.option,
                    }}
                    autoHighlightNotRequired={true}
                    name="corporate"
                    id="corporate"
                    size="small"
                    options={corporateNameData || []}
                    getOptionLabel={(option) => {
                      return option.corporateName || '';
                    }}
                    freeSolo
                    onInputChange={(e, inputVal) => {
                      handleInputChange(e, inputVal, corporateNameData, 'corporateName');
                    }}
                    onBlur={(e) => {
                      if (e?.target?.value) {
                        setFieldValue('corporate', {
                          corporateName: e?.target?.value,
                        });
                      }
                    }}
                    onChange={(event, value) => {
                      if (event?.key === 'Enter' && typeof value !== 'object') {
                        setFieldValue('corporate', {
                          corporateName: value,
                        });
                      } else {
                        if (value && value?.corporateName) {
                          dispatch(fetchSiteDataBasedOnCorporate(value?.corporateId));
                          setCompanyIds((ids) => ({
                            ...ids,
                            corporateId: value?.corporateId,
                          }));
                        }
                        if (!value?.corporateName) {
                          dispatch(resetGetServiceClientData());
                          dispatch(resetSiteDataOnCorporate());
                        }
                        setFieldValue('site', '');
                        setFieldValue('serviceClient', '');
                        setFieldValue('corporate', value);
                        dispatch(resetGetServiceClientData());
                        dispatch(resetSiteDataOnCorporate());
                      }
                    }}
                    value={values.corporate}
                    renderInput={(params) => (
                      <div className="select-field">
                        <TextField
                          {...params}
                          variant="outlined"
                          margin="dense"
                          label="Corporate Name"
                          placeholder="Select Corporate Name"
                        />
                      </div>
                    )}
                  />
                </div>
                <div className={'col-sm-6 col-md-4 col-lg-4 form-group billingindicator-closeicon'}>
                  <Autocomplete
                    classes={{
                      option: classes.option,
                    }}
                    autoHighlightNotRequired={true}
                    name="site"
                    id="site"
                    size="small"
                    options={siteDataOnCorporate || []}
                    getOptionLabel={(option) => {
                      return option.siteName || '';
                    }}
                    freeSolo
                    onInputChange={(e, inputVal) => {
                      handleInputChange(e, inputVal, siteDataOnCorporate, 'siteName');
                    }}
                    onBlur={(e) => {
                      if (e?.target?.value) {
                        setFieldValue('site', {
                          siteName: e?.target?.value,
                        });
                      }
                    }}
                    onChange={(event, value) => {
                      if (event?.key === 'Enter' && typeof value !== 'object') {
                        setFieldValue('site', {
                          siteName: value,
                        });
                      } else {
                        if (value && value?.siteName) {
                          dispatch(
                            fetchServiceClientDropDownData(
                              value?.siteId,
                              companyIds?.corporateId,
                              companyIds?.companyId,
                            ),
                          );
                        }
                        if (!value?.siteId) {
                          dispatch(resetGetServiceClientData());
                        }
                        setFieldValue('serviceClient', '');
                        setFieldValue('site', value);
                        dispatch(resetGetServiceClientData());
                      }
                    }}
                    value={values.site}
                    renderInput={(params) => (
                      <div className="select-field">
                        <TextField
                          {...params}
                          variant="outlined"
                          margin="dense"
                          label="Site Name"
                          placeholder="Select Site Name"
                        />
                      </div>
                    )}
                  />
                </div>
                <div className={'col-sm-6 col-md-4 col-lg-4 form-group billingindicator-closeicon'}>
                  <Autocomplete
                    classes={{
                      option: classes.option,
                    }}
                    autoHighlightNotRequired={true}
                    name="serviceClient"
                    id="serviceClient"
                    size="small"
                    options={getServiceClientData || []}
                    getOptionLabel={(option) => {
                      return option.serviceClientName || '';
                    }}
                    freeSolo
                    onInputChange={(e, inputVal) => {
                      handleInputChange(e, inputVal, siteDataOnCorporate, 'serviceClientName');
                    }}
                    onBlur={(e) => {
                      if (e?.target?.value) {
                        setFieldValue('serviceClient', {
                          serviceClientName: e?.target?.value,
                        });
                      }
                    }}
                    onChange={(event, value) => {
                      if (event?.key === 'Enter' && typeof value !== 'object') {
                        setFieldValue('serviceClient', {
                          serviceClientName: value,
                        });
                      } else {
                        setFieldValue('serviceClient', value);
                      }
                    }}
                    value={values.serviceClient}
                    renderInput={(params) => (
                      <div className="select-field">
                        <TextField
                          {...params}
                          variant="outlined"
                          margin="dense"
                          label="Client Name"
                          placeholder="Select Client Name"
                        />
                      </div>
                    )}
                  />
                </div>

                <div className="col-xs-4 col-sm-6 col-md-12 col-lg-12 mb-3">
                  <div className="d-flex justify-content-center">
                    <Button
                      variant="outlined"
                      className={`mr-1 reset-btn`}
                      onClick={() => {
                        resetForm(initialValues);
                        setSubmit(true);
                        dispatch(resetGetServiceClientData());
                        dispatch(resetSiteDataOnCorporate());
                        dispatch(resetCorporateNameData());
                        setCompanyIds({
                          corporateId: 0,
                          companyId: 0,
                        });
                        onClear();
                      }}
                    >
                      Reset
                    </Button>
                    <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                      Search
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
      <div>
        <BillingMappingTable
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          setValue={setValue}
          setTabLabels={setTabLabels}
        />
      </div>
    </>
  );
};

export default BillingSearchForm;
